export default {
      id: "article-views-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#article-views",
      toString: function () {
        return this.url;
      }
    }